module.exports = "<footer class=\"app-footer\">\n  <span><a href=\"https://www.daviworld.net\">daviworld</a> &copy; {{getFullYear()}}</span>\n  <span class=\"ml-auto\">Powered by <a href=\"https://www.daviworld.net\">daviworld</a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main